import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api/api.service';
import { SignupService } from 'src/app/services/signup/signup.service';

import Utils, { GetHelper } from 'src/app/helpers/utils';
import { StorageService } from 'src/app/services/storage/storage.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import UIDefaultTheme from 'src/themes';
import { LoadingService } from 'src/app/services/Loading/loading.service';
import { permission } from 'src/app/data/permissions';
import { SignupUnifiedPersonalComponent } from './signup-unified-personal/signup-unified-personal.component';

@Component({
  selector: 'app-signup-unified-basic',
  templateUrl: './signup-unified-basic.component.html',
  styleUrls: ['./signup-unified-basic.component.scss'],
})
export class SignupUnifiedBasicComponent implements OnInit, OnDestroy {
  steps: Step[] = [
    {
      icon: 'fas fa-fingerprint',
      svg: 'assets/images/icon-fingerprint-active.svg',
      title: 'Dados pessoais',
      slug: 'personal',
    },
    {
      icon: 'fas fa-unlock-alt',
      svg: 'assets/images/icon-lock.svg',
      title: 'Senha de acesso',
      slug: 'password',
    },
    // {
    //   icon: 'fas fa-id-card-alt',
    //   svg: 'assets/images/icon-profile.svg',
    //   title: 'Perfil de usuário',
    //   slug: 'profile',
    // },
    // {
    //   icon: 'fas fa-ellipsis-h',
    //   svg: 'assets/images/icon-more.svg',
    //   title: '',
    //   slug: 'more',
    // },
  ];

  // Getter para retornar os steps filtrados (sem perfil quando houver convite)
  get filteredSteps(): Step[] {
    if (this.haveInvite) {
      // Quando houver convite, mostra apenas "Dados pessoais" e "Senha de acesso"
      return this.steps.filter(
        (step) => step.slug === 'personal' || step.slug === 'password',
      );
    }
    return this.steps;
  }

  message = ' Todos os campos são de preenchimento obrigatório';

  _activeStep = 0;

  loading = false;

  hided = false;

  validateForm = false;

  showSupportModal = false;

  label: string | null = null;
  name: string | null = '';
  isPF: boolean = false;
  isFund: boolean = false;
  role: string | null = null;

  haveInvite = false;
  inviteChecked: boolean = false; // Flag para indicar que a verificação do convite foi concluída

  // Invite status properties
  inviteStatus: string | null = null;
  inviteUsed: boolean = false;
  inviteCanceled: boolean = false;
  inviteExpired: boolean = false;
  isInviteValid: boolean = true;

  // New paper properties
  hasNewPaper: boolean = false;
  newPaper: string | null = null;
  registerUuid: string | null = null;

  // Modal properties
  showLinkInviteModal = false;
  showInvalidTokenModal = false;

  // Invite ID para comparação
  inviteId: number | null = null;
  isSameInviteAsActiveRegister: boolean = false;

  @ViewChild(SignupUnifiedPersonalComponent)
  personalComponent: SignupUnifiedPersonalComponent;

  set activeStep(val: number) {
    this._activeStep = val;
  }

  get activeStep() {
    return this._activeStep;
  }

  public UIDefaultTheme = UIDefaultTheme;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    public signupService: SignupService,
    private storageService: StorageService,
    private toastService: ToastService,
    private authService: AuthService,
    public loadingService: LoadingService,
  ) {
    this.signupService.submitBasicForm.subscribe(() => {
      this.proceed();
    });
  }

  ngOnDestroy(): void {
    this.storageService.removeSession('signup_basic_personal');
  }

  ngOnInit(): void {
    let urlParts = this.router.url.split('/basic')[0].split('/');
    let range = urlParts.length;
    this.role = urlParts[range - 1];

    console.log('[SIGNUP-UNIFIED-BASIC] ngOnInit - URL:', this.router.url);
    console.log('[SIGNUP-UNIFIED-BASIC] ngOnInit - Role:', this.role);

    // Verificar se há parâmetro new_paper na URL
    this.route.queryParams.subscribe((params) => {
      console.log(
        '[SIGNUP-UNIFIED-BASIC] queryParams subscribe - params:',
        params,
      );

      if (params['new_paper']) {
        console.log(
          '[SIGNUP-UNIFIED-BASIC] new_paper detectado:',
          params['new_paper'],
        );
        this.hasNewPaper = true;
        this.newPaper = params['new_paper'];
        this.registerUuid = params['register_uuid'] || null;
        const noAccess =
          params['no_access'] === 'true' || params['no_access'] === 'True';

        console.log('[SIGNUP-UNIFIED-BASIC] hasNewPaper:', this.hasNewPaper);
        console.log('[SIGNUP-UNIFIED-BASIC] newPaper:', this.newPaper);
        console.log('[SIGNUP-UNIFIED-BASIC] registerUuid:', this.registerUuid);
        console.log('[SIGNUP-UNIFIED-BASIC] noAccess:', noAccess);

        // Verificar se o usuário está logado e se o register_uuid é diferente
        const user = this.authService.getUser();
        const token = this.authService.getToken();

        console.log('[SIGNUP-UNIFIED-BASIC] User logado:', !!user);
        console.log('[SIGNUP-UNIFIED-BASIC] Token existe:', !!token);

        if (user && this.registerUuid) {
          const activeRegisterId =
            user.active_register?.register?.id?.toString();
          const urlRegisterId = this.registerUuid.toString();

          console.log(
            '[SIGNUP-UNIFIED-BASIC] activeRegisterId:',
            activeRegisterId,
          );
          console.log('[SIGNUP-UNIFIED-BASIC] urlRegisterId:', urlRegisterId);

          // Se os IDs são diferentes, mostrar modal pedindo para deslogar
          if (activeRegisterId && activeRegisterId !== urlRegisterId) {
            console.log(
              '[SIGNUP-UNIFIED-BASIC] IDs diferentes - mostrando modal',
            );
            this.inviteChecked = true;
            this.showLinkInviteModal = true;
            return;
          }
        }

        // Se há no_access, buscar dados do convite para determinar PF/PJ/Fundo
        // Isso evita mostrar a etapa de seleção de perfil
        if (noAccess) {
          const inviteToken = this.route.snapshot.params.token;
          if (inviteToken) {
            console.log(
              '[SIGNUP-UNIFIED-BASIC] Buscando dados do convite (no_access=true)',
            );
            this.getBasicInfo(inviteToken)
              .then(() => {
                console.log(
                  '[SIGNUP-UNIFIED-BASIC] Dados do convite carregados',
                );
              })
              .catch((error) => {
                console.error(
                  '[SIGNUP-UNIFIED-BASIC] Erro ao buscar dados do convite:',
                  error,
                );
                this.inviteChecked = true;
              });
          } else {
            console.log(
              '[SIGNUP-UNIFIED-BASIC] Sem token do convite, marcando inviteChecked como true',
            );
            this.inviteChecked = true;
          }
        } else {
          console.log(
            '[SIGNUP-UNIFIED-BASIC] Marcando inviteChecked como true (sem no_access)',
          );
          this.inviteChecked = true; // Marcar como verificado para mostrar o componente de login
        }
        console.log(
          '[SIGNUP-UNIFIED-BASIC] inviteChecked:',
          this.inviteChecked,
        );
      } else {
        console.log('[SIGNUP-UNIFIED-BASIC] Sem new_paper - fluxo normal');
        this.hasNewPaper = false;
        this.getBasicInfo(this.route.snapshot.params.token);
      }
    });

    document.onkeydown = (e) => {
      if (e.key === 'Enter') {
        this.proceed();
      }
    };
  }

  async changeActiveRegister(id: number) {
    try {
      await this.apiService.patch({
        route: `user/me/`,
        token: true,
        body: {
          active_register: id,
        },
      });

      const { data } = await this.apiService.get<ApiResponse<NewLoginResponse>>(
        {
          route: 'user/me/',
          token: true,
        },
      );

      this.storageService.setPermissionType(data.type_permission);

      this.authService.setUser(data);

      const {
        active_register: { register },
      } = data;

      this.router.navigate([
        `/signup/${register.role.applicable}/${register.type.toLowerCase()}`,
      ]);
    } catch (error) {
      console.error(error);
      this.toastService.show('error', 'Erro!', 'Erro ao alterar conta ativa');
    }
  }

  async getBasicInfo(token: string) {
    if (!token) {
      // Se não houver token, marca como verificado para mostrar os inputs
      this.inviteChecked = true;
      return;
    }

    this.loadingService.show('');

    try {
      const res = await this.apiService.get({
        route: `api/v3/registration/invite/public/`,
        params: { token },
      });

      if (!res.data) {
        this.loadingService.hide();
        this.inviteChecked = true;
        return;
      }

      // Define as variáveis de status do invite ANTES de qualquer verificação
      // para que o badge apareça desde o início, mesmo com modal aberto
      this.haveInvite = true;
      this.inviteStatus = res.data.status || null;
      this.inviteUsed = res.data.used || false;
      this.inviteCanceled = res.data.canceled || false;
      this.inviteId = res.data.id || null;

      // Verifica se está expirado (por status ou por data)
      if (this.inviteStatus === 'expired') {
        this.inviteExpired = true;
      } else if (res.data.expires_at) {
        const expirationDate = new Date(res.data.expires_at);
        const today = new Date();
        this.inviteExpired = expirationDate < today;
      }

      // Verifica se o invite é válido para uso
      this.isInviteValid =
        !this.inviteUsed && !this.inviteCanceled && !this.inviteExpired;

      // Processa dados do invite (nome, documento, etc.) para exibir no badge
      const inviteData = res.data.data || res.data;

      if (inviteData.name) {
        this.name = inviteData.name;
      }

      const user = this.authService.getUser();

      if (user) {
        // Verificar se o invite é o mesmo do active_register
        const activeRegisterInviteId =
          user.active_register?.register?.invite?.id;
        this.isSameInviteAsActiveRegister =
          this.inviteId !== null &&
          activeRegisterInviteId !== null &&
          this.inviteId === activeRegisterInviteId;

        this.loadingService.hide();
        this.inviteChecked = true;
        this.showLinkInviteModal = true;
        return;
      }

      // Se o invite não for válido, não marca como viewed e não continua
      if (!this.isInviteValid) {
        this.loadingService.hide();
        this.inviteChecked = true; // Marca como verificado mesmo se inválido
        return;
      }

      // Marca o convite como "viewed" apenas se:
      // - Tiver ID
      // - Status for "sent" (não "viewed" ou "used")
      // - Used não for true
      if (res.data.id) {
        const status = res.data.status;
        const used = res.data.used;

        // Só marca como "viewed" se o status for "sent" e não estiver usado
        if (status === 'sent' && !used && status !== 'viewed') {
          try {
            await this.apiService.patch({
              route: `api/v3/registration/invite/public/`,
              body: {
                token: token,
                status: 'viewed',
              },
              token: false,
            });
            // Atualiza o status após marcar como viewed
            this.inviteStatus = 'viewed';
          } catch (patchError) {
            // Não bloqueia o fluxo se o PATCH falhar
            console.error('Erro ao marcar convite como viewed:', patchError);
          }
        }
      }

      if (inviteData.document) {
        this.isPF = inviteData.document.length <= 14;

        this.isFund = res.data.shareholder_fi || inviteData.shareholder_fi;
      }

      if (this.role === 'provider') {
        const agents = inviteData.agent || res.data.agent || [];
        if (Array.isArray(agents) && agents.length > 0) {
          this.label = agents.map((_: any) => _.name || _).join(', ');
        }
      }

      if (this.role === 'assignor') {
        this.label = `Cedente pessoa ${this.isPF ? 'física' : 'jurídica'}`;
      }

      if (this.role === 'guarantor') {
        this.label = `Avalista pessoa ${this.isPF ? 'física' : 'jurídica'}`;
      }

      if (inviteData.document && inviteData.document.length > 14) {
        this.name = inviteData.name.toUpperCase();
      }
    } catch (error) {
      if (error.status === 404) {
        this.showInvalidTokenModal = true;
      }

      console.error(error);
    } finally {
      this.loadingService.hide();
      this.inviteChecked = true; // Marca como verificado após concluir a verificação
    }
  }

  canProceed() {
    switch (this.activeStep) {
      case 0:
        return this.signupService.getBasicFormStatus('personal');

      case 1:
        return this.signupService.getBasicFormStatus('password');

      case 2:
        return this.signupService.getBasicFormStatus('profile');

      default:
        return true;
    }
  }

  get hasNoAccess(): boolean {
    const queryParams = this.route.snapshot.queryParams;
    return (
      queryParams['no_access'] === 'true' || queryParams['no_access'] === 'True'
    );
  }

  getButtonIcon() {
    return this.canProceed()
      ? 'assets/images/icon_button_arrow.svg'
      : 'assets/images/icon_button_block.svg';
  }

  goBack() {
    if (this.activeStep > 0) {
      const previousStep = this.activeStep - 1;

      // Se está voltando da página de senha (step 1) para dados pessoais (step 0)
      // Limpa os dados de senha para que o usuário tenha que digitar novamente
      if (this.activeStep === 1 && previousStep === 0) {
        this.signupService.setBasicFormData('password', {
          password: '',
          confirmPassword: '',
        });
        this.signupService.setBasicFormStatus('password', false);
      }

      this.activeStep = previousStep;

      // Atualiza a mensagem baseada no passo atual
      switch (this.activeStep) {
        case 0:
          this.message = 'Todos os campos são de preenchimento obrigatório';
          this.hided = false;
          break;
        case 1:
          this.message = 'Defina uma senha para seguir seu cadastro';
          this.hided = false;
          break;
        case 2:
          this.message = 'Selecione uma opção para seguir seu cadastro';
          this.hided = true;
          break;
        default:
          this.message = 'Todos os campos são de preenchimento obrigatório';
          this.hided = false;
      }
    }
  }

  canGoBack(): boolean {
    return this.activeStep > 0;
  }

  //   async validateEmail() {
  //     const personalData: BasicPersonalValues =
  //       this.signupService.getBasicFormData('personal');

  //     try {
  //       const res = await this.apiService.post<ValidateFieldResponse>({
  //         route: 'validate-email-exists/',

  //         body: { email: personalData.email },
  //       });

  //       return res.exists;
  //     } catch (error) {}

  //     return true;
  //   }

  async validateCpf() {
    const personalData: BasicPersonalValues =
      this.signupService.getBasicFormData('personal');

    try {
      const res = await this.apiService.post<ValidateFieldResponse>({
        route: 'validate-cpf-exists/',

        body: { cpf: personalData.document },
      });

      return res.exists;
    } catch (error) {}

    return true;
  }

  async validatePhone() {
    const personalData: BasicPersonalValues =
      this.signupService.getBasicFormData('personal');

    try {
      // const res = await this.apiService.post<ValidateFieldResponse>({
      //   route: 'validate-phone-exists/',

      //   body: { phone: Utils.onlyNumbers(personalData.phone_number) },
      // });

      // return res.exists;

      return false;
    } catch (error) {
      console.error(error);
    }

    return true;
  }

  toggleSupportModal() {
    this.showSupportModal = !this.showSupportModal;
  }

  closeLinkInviteModal() {
    this.showLinkInviteModal = false;
  }

  closeInvalidTokenModal() {
    this.showInvalidTokenModal = false;
    this.router.navigate(['/app/dashboard']);
  }

  async cancelLinkInvite() {
    // Se o convite está usado e é o mesmo do active_register, retomar cadastro
    if (this.inviteUsed && this.isSameInviteAsActiveRegister) {
      this.resumeSignup();
      return;
    }

    this.storageService.remove('edit_user');
    this.closeLinkInviteModal();
    this.router.navigate(['/app/dashboard']);
  }

  async resumeSignup() {
    const user = this.authService.getUser();
    if (!user?.active_register?.register) {
      this.closeLinkInviteModal();
      this.router.navigate(['/app/dashboard']);
      return;
    }

    const { role, type, id: registerId } = user.active_register.register;
    const invite = user.active_register.register.invite;

    // Determina o tipo (PF/PJ) com fallback para invite.data.person_type
    const finalType =
      type ??
      (invite?.data?.person_type ||
        (invite?.data?.document && invite.data.document.length > 14
          ? 'PJ'
          : 'PF'));

    // Determina o applicable (role) com fallback para invite.data.role
    const finalApplicable = (role && role.applicable) ?? invite?.data?.role;

    const typeLower = finalType.toLowerCase();

    this.closeLinkInviteModal();

    // Redireciona para o fluxo de cadastro
    if (registerId) {
      this.router.navigate([
        `/signup/${finalApplicable}/${typeLower}/${registerId}`,
      ]);
    } else {
      this.router.navigate([`/signup/${finalApplicable}/${typeLower}`]);
    }
  }

  // Nova função: logout sem redirecionamento
  async logoutWithoutRedirect() {
    try {
      // Limpar tudo de forma assíncrona sem redirecionar
      await this.authService.clearUser();

      // Verificar uma última vez se tudo foi limpo
      const userStillExists = localStorage.getItem('@app:user');
      const tokenStillExists = localStorage.getItem('@app:token');

      if (userStillExists || tokenStillExists) {
        // Se ainda existir, limpar manualmente
        if (userStillExists) localStorage.removeItem('@app:user');
        if (tokenStillExists) localStorage.removeItem('@app:token');

        // Aguardar um pouco mais para garantir
        await new Promise((resolve) => setTimeout(resolve, 50));
      }

      // Fechar o modal
      this.closeLinkInviteModal();

      // Recarregar os dados do convite (agora sem usuário logado)
      await this.getBasicInfo(this.route.snapshot.params.token);

      // Reavaliar condição no componente personal após logout
      if (this.personalComponent && this.hasNewPaper) {
        await this.personalComponent.recheckLoginCondition();
      }
    } catch (error) {
      console.error('Erro ao fazer logout:', error);
      this.toastService.show('error', 'Erro!', 'Erro ao fazer logout');
    }
  }

  // Helper methods for modal content
  getLinkInviteModalTitle() {
    return 'Atenção';
  }

  getLinkInviteModalMessage() {
    const user = this.authService.getUser();

    // Se o convite está usado e é o mesmo do active_register
    if (this.inviteUsed && this.isSameInviteAsActiveRegister) {
      return `Você já passou por essa etapa de preenchimento. Você pode deslogar para iniciar um novo cadastro ou retomar o cadastro de onde parou.`;
    }

    return `Você está autenticado como ${user?.first_name} ${user?.last_name}. Para continuar com este convite, você precisa se deslogar primeiro.`;
  }

  getLinkInviteConfirmText() {
    // Se o convite está usado e é o mesmo do active_register, mudar o texto
    if (this.inviteUsed && this.isSameInviteAsActiveRegister) {
      return 'Deslogar';
    }
    return 'Deslogar e continuar';
  }

  getLinkInviteCancelText() {
    // Se o convite está usado e é o mesmo do active_register, mudar o texto
    if (this.inviteUsed && this.isSameInviteAsActiveRegister) {
      return 'Retomar cadastro';
    }
    return 'Retornar ao painel';
  }

  getLinkInviteMiddleText() {
    // Não usar middleText neste caso, apenas cancel e confirm
    return '';
  }

  getInvalidTokenModalTitle() {
    return 'Atenção';
  }

  getInvalidTokenModalMessage() {
    return 'O token informado é inválido ou já foi utilizado.';
  }

  getInvalidTokenConfirmText() {
    return 'Ok';
  }

  async loginUser() {
    const { email, document }: BasicPersonalValues =
      this.signupService.getBasicFormData('personal');
    const { password }: BasicPasswordValues =
      this.signupService.getBasicFormData('password');
    const { type }: BasicProfileValues =
      this.signupService.getBasicFormData('profile');

    try {
      const { data } = await this.apiService.post<
        ApiResponse<NewLoginResponse>
      >({
        route: 'new-login/',
        body: { username: Utils.onlyNumbers(document), password },
      });

      this.storageService.setPermissionType(data.type_permission);

      let permissionsArr =
        data.active_register.permissions_role &&
        data.active_register.permissions_role.permissions
          ? data.active_register.permissions_role.permissions
          : [];

      //   if (data.type_permission === 'owner') permissionsArr = permission;

      // if (window.location.href.includes('dev')) {
      //   permissionsArr = permission;
      // }

      this.authService.setToken(data.tokens.access);
      this.authService.setUser(data);
      this.authService.permissions = permissionsArr;
      this.storageService.set('permissions', permissionsArr, true);

      const { role, type } = data.active_register.register;
      const invite = data.active_register.register.invite;

      // Determina o tipo (PF/PJ) com fallback para invite.data.person_type
      const finalType =
        type ??
        (invite?.data?.person_type ||
          (invite?.data?.document && invite.data.document.length > 14
            ? 'PJ'
            : 'PF'));

      // Determina o applicable (role) com fallback para invite.data.role
      const finalApplicable = (role && role.applicable) ?? invite?.data?.role;

      const typeLower = finalType.toLowerCase();
      const personId = data.active_register.register.id;

      let route = `/signup/${finalApplicable}/${typeLower}/${personId}`;

      this.storageService.removeSession('signup_basic_personal');
      this.router.navigate([route]);

      return true;
    } catch (error) {
      return false;
    }
  }

  async registerUser() {
    this.loading = true;

    const personalData: BasicPersonalValues =
      this.signupService.getBasicFormData('personal');
    const personalHelper = new GetHelper(personalData);

    const passwordData: BasicPasswordValues =
      this.signupService.getBasicFormData('password');
    const passwordHelper = new GetHelper(passwordData);

    const profileData: BasicProfileValues =
      this.signupService.getBasicFormData('profile');
    const profileHelper = new GetHelper(profileData);

    const names = personalHelper.get('full_name').split(' ');

    const [first_name, ...last_names] = names;

    const last_name = last_names.join(' ');

    // Verificar se é no_access (new_paper + no_access=true)
    const queryParams = this.route.snapshot.queryParams;
    const noAccess =
      queryParams['no_access'] === 'true' ||
      queryParams['no_access'] === 'True';
    const registerUuid = queryParams['register_uuid'];
    const inviteToken = this.route.snapshot.params.token;

    if (noAccess && registerUuid && inviteToken) {
      // Usar novo endpoint basic-access-register
      const payload = {
        user: {
          username: Utils.onlyNumbers(personalHelper.get('document')),
          first_name: first_name,
          last_name: last_name,
          email: personalHelper.get('email'),
          password: passwordHelper.get('password'),
        },
        profile: {
          document: {
            type:
              personalHelper.get('document_type') === 'other'
                ? personalHelper.get('document_name')
                : personalHelper.get('document_type'),
            number: Utils.onlyNumbers(personalHelper.get('document')),
          },
          nationality: String(Number(personalHelper.get('nacionality'))),
        },
        phone: {
          code: personalHelper.get('phone_ddi'),
          number: Utils.onlyNumbers(personalHelper.get('phone_number')),
          branch: '0',
        },
      };

      try {
        const res = await this.apiService.post({
          route: 'basic-access-register/',
          params: {
            invite: inviteToken,
            register_uuid: registerUuid,
          },
          body: payload,
        });

        console.log('[BASIC-ACCESS-REGISTER] Resposta completa do POST:', res);
        console.log('[BASIC-ACCESS-REGISTER] res.data:', res?.data);

        // O endpoint não retorna tokens, então precisamos fazer login após o registro
        if (res?.data?.user || res?.data) {
          console.log(
            '[BASIC-ACCESS-REGISTER] Registro bem-sucedido, fazendo login...',
          );

          // Fazer login para obter os tokens
          const username = Utils.onlyNumbers(personalHelper.get('document'));
          const password = passwordHelper.get('password');

          try {
            const loginRes = await this.apiService.post<
              ApiResponse<NewLoginResponse>
            >({
              route: 'new-login/',
              body: { username, password },
            });

            console.log('[BASIC-ACCESS-REGISTER] Resposta do login:', loginRes);

            if (loginRes?.data?.tokens?.access) {
              const tokens = loginRes.data.tokens;
              const userData = loginRes.data;

              this.authService.setToken(tokens.access);
              this.authService.setUser(userData);

              // Buscar dados do invite UMA VEZ para fazer os PATCHs e pegar o tipo
              let inviteRes = null;
              let role = 'assignor';

              if (inviteToken) {
                console.log(
                  '[BASIC-ACCESS-REGISTER] Buscando dados do invite...',
                );
                inviteRes = await this.apiService.get({
                  route: `api/v3/registration/invite/public/`,
                  params: { token: inviteToken },
                });

                console.log(
                  '[BASIC-ACCESS-REGISTER] Resposta do invite:',
                  inviteRes,
                );

                // Pegar o tipo do invite AGORA
                if (inviteRes?.data?.type) {
                  role = inviteRes.data.type;
                  console.log('[BASIC-ACCESS-REGISTER] Role do invite:', role);
                }
              }

              // Se não pegou do invite, usar newPaper
              if (role === 'assignor' && queryParams['new_paper']) {
                role = queryParams['new_paper'];
                console.log(
                  '[BASIC-ACCESS-REGISTER] Usando newPaper como role:',
                  role,
                );
              }

              const registerId =
                userData?.active_register?.register?.id?.toString() ||
                registerUuid;
              const personType = (
                userData?.active_register?.register?.type || 'PF'
              ).toLowerCase();

              console.log('[BASIC-ACCESS-REGISTER] RegisterId:', registerId);
              console.log('[BASIC-ACCESS-REGISTER] PersonType:', personType);
              console.log('[BASIC-ACCESS-REGISTER] InviteToken:', inviteToken);
              console.log('[BASIC-ACCESS-REGISTER] Role determinado:', role);

              try {
                // 1. PATCH no register-step para definir como 'register' e 'general'
                console.log(
                  '[BASIC-ACCESS-REGISTER] Fazendo PATCH no register-step...',
                );
                if (personType === 'pf') {
                  await this.signupService.updateUserStepPF(
                    'register',
                    'general',
                    registerId,
                  );
                  console.log(
                    '[BASIC-ACCESS-REGISTER] PATCH register-step PF concluído',
                  );
                } else {
                  await this.signupService.updateUserStepCompany(
                    'register',
                    'general',
                    registerId,
                  );
                  console.log(
                    '[BASIC-ACCESS-REGISTER] PATCH register-step PJ concluído',
                  );
                }

                // 2. Usar os dados do invite já buscados para os PATCHs
                if (inviteRes?.data) {
                  console.log(
                    '[BASIC-ACCESS-REGISTER] Invite data:',
                    inviteRes.data,
                  );
                  console.log(
                    '[BASIC-ACCESS-REGISTER] Invite status:',
                    inviteRes.data.status,
                  );
                  console.log(
                    '[BASIC-ACCESS-REGISTER] Invited current role:',
                    inviteRes.data.invited_current_role,
                  );

                  // Marcar convite como usado (só se ainda não estiver usado)
                  if (inviteRes.data.status !== 'used') {
                    console.log(
                      '[BASIC-ACCESS-REGISTER] Marcando convite como usado...',
                    );
                    await this.apiService.patch({
                      route: `api/v3/registration/invite/public/`,
                      body: {
                        used: true,
                        status: 'used',
                        token: inviteToken,
                      },
                      token: true,
                    });
                    console.log(
                      '[BASIC-ACCESS-REGISTER] Convite marcado como usado',
                    );
                  } else {
                    console.log(
                      '[BASIC-ACCESS-REGISTER] Convite já estava como usado, pulando PATCH',
                    );
                  }

                  // Adicionar role_draft se houver invited_current_role
                  if (inviteRes.data.invited_current_role) {
                    console.log(
                      '[BASIC-ACCESS-REGISTER] Adicionando role_draft:',
                      inviteRes.data.invited_current_role,
                    );
                    await this.apiService.patch({
                      route: `api/v3/registration/registers/`,
                      body: {
                        register_uuid: registerId,
                        role_draft: inviteRes.data.invited_current_role,
                      },
                      token: true,
                    });
                    console.log(
                      '[BASIC-ACCESS-REGISTER] PATCH role_draft concluído',
                    );
                  } else {
                    console.log(
                      '[BASIC-ACCESS-REGISTER] Não há invited_current_role, pulando PATCH role_draft',
                    );
                  }
                } else {
                  console.log(
                    '[BASIC-ACCESS-REGISTER] InviteRes.data não existe',
                  );
                }
              } catch (error) {
                console.error(
                  '[BASIC-ACCESS-REGISTER] Erro ao fazer PATCHs após registro:',
                  error,
                );
                // Não bloqueia o redirecionamento mesmo se os PATCHs falharem
              }

              console.log(
                '[BASIC-ACCESS-REGISTER] Role final para redirecionamento:',
                role,
              );
              console.log(
                '[BASIC-ACCESS-REGISTER] PersonType final:',
                personType,
              );
              console.log(
                '[BASIC-ACCESS-REGISTER] RegisterId final:',
                registerId,
              );

              this.storageService.removeSession('signup_basic_personal');

              this.router.navigate(
                [`/signup/${role}/${personType}/${registerId}`],
                {
                  queryParams: {
                    new_paper: queryParams['new_paper'],
                    register_uuid: registerUuid,
                    no_access: queryParams['no_access'],
                  },
                },
              );

              console.log('[BASIC-ACCESS-REGISTER] Redirecionamento concluído');
              this.loading = false;
              return false; // Retornar false para evitar chamar loginUser() novamente
            } else {
              console.log('[BASIC-ACCESS-REGISTER] Login não retornou tokens');
            }
          } catch (loginError: any) {
            console.error(
              '[BASIC-ACCESS-REGISTER] Erro ao fazer login:',
              loginError,
            );
            this.toastService.show(
              'error',
              'Erro!',
              `Erro ao fazer login após criar acesso\n\r${
                loginError.error?.message || JSON.stringify(loginError.error)
              }`,
            );
            this.loading = false;
            return false;
          }
        } else {
          console.log(
            '[BASIC-ACCESS-REGISTER] Registro não retornou dados esperados',
          );
        }

        this.storageService.removeSession('signup_basic_personal');
        return res;
      } catch (error: any) {
        console.error(error);
        this.toastService.show(
          'error',
          'Erro!',
          `Erro ao criar acesso\n\r${
            error.error?.message || JSON.stringify(error.error)
          }`,
        );
        this.loading = false;
        return false;
      }
    } else {
      // Fluxo normal (endpoint atual)
      const payload = {
        user: {
          email: personalHelper.get('email'),
          username: Utils.onlyNumbers(personalHelper.get('document')),
          password: passwordHelper.get('password'),
          first_name: first_name,
          last_name: last_name,
          type: profileHelper.get('type'),
          role: profileHelper.get('id'),
          agent: personalHelper.get('agent') ?? [],
        },
        fund: personalHelper.get('fund'),
        invite: inviteToken,
        profile: {
          document: {
            user: 1,
            number: Utils.onlyNumbers(personalHelper.get('document')),
            type:
              personalHelper.get('document_type') === 'other'
                ? personalHelper.get('document_name')
                : personalHelper.get('document_type'),
            dispatching_agency: null,
            uf: null,
            expedition_date: null,
          },
          nationality: Number(personalHelper.get('nacionality')),
        },

        phone: {
          user: 1,
          code: Number(personalHelper.get('phone_ddi')),
          number: Utils.onlyNumbers(personalHelper.get('phone_number')),
          branch: 0,
        },
      };

      try {
        const res = await this.apiService.post({
          route: 'new-register/',
          body: payload,
        });

        this.storageService.setPreUser(res);

        this.storageService.removeSession('signup_basic_personal');

        return res;
      } catch (error: any) {
        console.error(error);

        this.toastService.show(
          'error',
          'Erro!',
          `Erro ao concluir cadastro\n\r${JSON.stringify(error.error)}`,
        );
      }

      this.loading = false;
      return false;
    }
  }

  async markInviteAsUsed() {
    if (!this.route.snapshot.params.token) {
      return;
    }

    try {
      await this.apiService.patch({
        route: `api/v3/registration/invite/public/`,
        body: {
          used: true,
          status: 'used',
          token: this.route.snapshot.params.token,
        },
        token: true,
      });

      // Limpa o sessionStorage após marcar o convite como utilizado
      this.storageService.removeSession('signup_basic_personal');
    } catch (patchError) {
      // Não bloqueia o fluxo se o PATCH falhar
      console.error('Erro ao marcar convite como used:', patchError);
      // Mesmo em caso de erro, limpa o sessionStorage
      this.storageService.removeSession('signup_basic_personal');
    }
  }

  async proceed() {
    if (this.canProceed()) {
      switch (this.activeStep) {
        case 0:
          this.loadingService.show('');
          try {
            const response = await Promise.all([
              //   this.validateEmail(),
              this.validateCpf(),
              this.validatePhone(),
            ]);
            this.loadingService.hide();

            let message = [];

            // if (response[0]) {
            //   message.push('Este e-mail ja está em uso');
            if (response[0]) {
              message.push('Este CPF ja está em uso');
            } else if (response[1]) {
              message.push('Este Telefone ja está em uso');
            }

            if (response.every((r) => !r)) {
              const personalData: BasicPersonalValues =
                this.signupService.getBasicFormData('personal');

              this.storageService.setPreUser({ email: personalData.email });

              //   let sendSMS = true;
              let sendSMS = false;

              if (
                window.location.href.includes('stage') ||
                window.location.href.includes('localhost')
              ) {
                sendSMS = false;
              }

              if (sendSMS) {
                await this.apiService.post({
                  route: 'request-token/',
                  body: {
                    username: personalData.document,
                    email: personalData.email,
                    phone: Utils.onlyNumbers(personalData.phone_number),
                    channel: 'all',
                  },
                });

                this.validateForm = true;
              } else {
                // Mostra loading enquanto muda de step (2 segundos para evitar tela branca)
                this.loadingService.show('');
                setTimeout(() => {
                  this.activeStep = 1;
                  this.message = 'Defina uma senha para seguir seu cadastro';
                  this.loadingService.hide();
                }, 2000);
              }
            } else {
              this.toastService.show('error', 'Erro!', message.join('\n\r'));
            }
          } catch (error) {
            this.toastService.show(
              'error',
              'Erro',
              'Erro ao verificar dados e enviar token',
            );
          }

          break;

        case 1:
          if (this.haveInvite) {
            const roles = this.signupService.getRoles();
            const type = this.isPF ? 'PF' : 'PJ';

            const profile = roles
              .filter(
                (role) =>
                  role.is_visible &&
                  (role.applicable === 'all' || role.applicable === this.role),
              )
              .find((_role) =>
                this.isFund
                  ? _role.slug === `${this.role.toUpperCase()}-PJ-FI`
                  : _role.slug.split('-')[2] === type,
              );

            const roleValues = profile?.slug ? profile.slug.split('-') : [];

            this.signupService.setBasicFormData('profile', {
              type: roleValues[1],
              role: roleValues[2],
              id: profile?.id,
            });

            if (this.isPF) {
              // Mostrar loading spinner durante registro e login
              this.loadingService.show('');

              try {
                const _registered = await this.registerUser();

                if (_registered) {
                  // this.toastService.show(
                  //   'info',
                  //   'Sucesso!',
                  //   'Cadastro concluido, acessando na plataforma...'
                  // );

                  const res = await this.loginUser();

                  if (res) {
                    // Marca o convite como "used" após autenticação bem-sucedida
                    await this.markInviteAsUsed();
                  } else {
                    this.loadingService.hide();
                    this.toastService.show(
                      'info',
                      'Sucesso',
                      'Erro ao acessar plataforma, logue-se na aplicação',
                    );
                    this.router.navigate(['/login']);
                  }
                } else {
                  this.loadingService.hide();
                }
              } catch (error) {
                this.loadingService.hide();
                console.error('Erro durante registro/login:', error);
              }
            } else {
              this.hided = false;
              this.activeStep = 3;
            }

            this.message = `Alguns campos são de preenchimento obrigatório`;
            break;
          }

          this.activeStep = 2;
          this.message = 'Selecione uma opção para seguir seu cadastro';
          this.hided = true;
          break;

        case 2:
          const personalValues: BasicProfileValues =
            this.signupService.getBasicFormData('profile');

          if (personalValues) {
            if (personalValues.type === 'PF') {
              // Mostrar loading spinner durante registro e login
              this.loadingService.show('');

              try {
                const _registered = await this.registerUser();

                if (_registered) {
                  // this.toastService.show(
                  //   'info',
                  //   'Sucesso!',
                  //   'Cadastro concluido, acessando na plataforma...'
                  // );

                  const res = await this.loginUser();

                  if (res) {
                    // Marca o convite como "used" após autenticação bem-sucedida
                    await this.markInviteAsUsed();
                  } else {
                    this.loadingService.hide();
                    this.toastService.show(
                      'info',
                      'Sucesso',
                      'Erro ao acessar plataforma, logue-se na aplicação',
                    );
                    this.router.navigate(['/login']);
                  }
                } else {
                  this.loadingService.hide();
                }
              } catch (error) {
                this.loadingService.hide();
                console.error('Erro durante registro/login:', error);
              }
            } else {
              this.hided = false;
              this.activeStep = 3;
            }
          }
          this.message = `Alguns campos são de preenchimento obrigatório`;
          break;

        case 3:
          // Mostrar loading spinner durante registro e login
          this.loadingService.show('');

          try {
            const _registered = await this.registerUser();

            if (_registered) {
              // this.toastService.show(
              //   'info',
              //   'Sucesso!',
              //   'Cadastro concluido, acessando na plataforma...'
              // );

              const res = await this.loginUser();

              if (res) {
                // Marca o convite como "used" após autenticação bem-sucedida
                await this.markInviteAsUsed();
              } else {
                this.loadingService.hide();
                this.toastService.show(
                  'info',
                  'Sucesso',
                  'Erro ao acessar plataforma, logue-se na aplicação',
                );
                this.router.navigate(['/login']);
              }
            } else {
              this.loadingService.hide();
            }
          } catch (error) {
            this.loadingService.hide();
            console.error('Erro durante registro/login:', error);
          }
          break;

        default:
          break;
      }
    }
  }

  async onValidate({ valid }: ValidateResponse) {
    this.loading = true;

    if (valid) {
      this.toastService.show('info', 'Sucesso!', 'Token validado com sucesso');

      // Mostra loading por 2 segundos antes de mudar de step
      this.loadingService.show('');
      setTimeout(() => {
        this.activeStep = 1;
        this.message = 'Defina uma senha para seguir seu cadastro';
        this.loadingService.hide();
      }, 2000);
    } else {
      this.toastService.show('error', 'Erro!', 'Falha ao validar o token');
    }

    this.validateForm = false;

    this.loading = false;
  }

  getInviteStatusLabel(): string {
    if (this.inviteCanceled) return 'Cancelado';
    if (this.inviteExpired) return 'Expirado';
    if (this.inviteUsed) return 'Utilizado';
    if (this.inviteStatus === 'viewed') return 'Visualizado';
    if (this.inviteStatus === 'sent') return 'Enviado';
    return 'Pendente';
  }

  getInviteStatusClass(): string {
    if (this.inviteCanceled) return 'status-badge-canceled';
    if (this.inviteExpired) return 'status-badge-expired';
    if (this.inviteUsed) return 'status-badge-used';
    if (this.inviteStatus === 'viewed') return 'status-badge-viewed';
    if (this.inviteStatus === 'sent') return 'status-badge-sent';
    return 'status-badge-pending';
  }

  getInviteStatusMessage(): string {
    if (this.inviteUsed) {
      return 'Este convite já foi utilizado e não pode ser usado novamente.';
    }
    if (this.inviteCanceled) {
      return 'Este convite foi cancelado e não está mais disponível.';
    }
    if (this.inviteExpired) {
      return 'Este convite expirou e não está mais disponível.';
    }
    return '';
  }

  getInviteStatusTitle(): string {
    if (this.inviteCanceled) return 'cancelado';
    if (this.inviteExpired) return 'expirado';
    if (this.inviteUsed) return 'utilizado';
    return this.getInviteStatusLabel().toLowerCase();
  }

  getInviteStatusIcon(): string {
    if (this.inviteCanceled || this.inviteExpired) {
      return 'assets/images/icon-exclamation-circle.svg';
    }
    return 'assets/images/icon-check-filled.svg';
  }

  getInviteStatusContainerClass(): string {
    if (this.inviteCanceled || this.inviteExpired) {
      return 'invite-status-container-error';
    }
    return 'invite-status-container-success';
  }

  // Método helper para verificar se deve mostrar o stepper e os inputs
  shouldShowContent(): boolean {
    // Se não houver convite, mostra normalmente
    // Se houver convite, só mostra se for válido
    return !this.haveInvite || this.isInviteValid;
  }

  // Método para debug
  logDebugInfo(): string {
    console.log(
      '[SIGNUP-UNIFIED-BASIC] Debug Info - hasNewPaper:',
      this.hasNewPaper,
    );
    console.log(
      '[SIGNUP-UNIFIED-BASIC] Debug Info - inviteChecked:',
      this.inviteChecked,
    );
    console.log(
      '[SIGNUP-UNIFIED-BASIC] Debug Info - activeStep:',
      this.activeStep,
    );
    console.log('[SIGNUP-UNIFIED-BASIC] Debug Info - newPaper:', this.newPaper);
    console.log(
      '[SIGNUP-UNIFIED-BASIC] Debug Info - registerUuid:',
      this.registerUuid,
    );
    return '';
  }
}
